import IComponent from "components/commons/IComponent";
import "./ResultList.scoped.css";
import MiniPanel from "components/commons/MiniPanel";
import geometryTools from "utils/geometryTools";
import ReactDOM from "react-dom/client";
import config_graphical_search from "components/ZoomTo/config_graphical_search";
import DivTable from "components/commons/DivTable";
import moment from "moment";
import ZoomTo from "components/ZoomTo";
import config_textual_search from "components/ZoomTo/config_textual_search";
import React from "react";
import GetArcGISToken from "utils/GetArcGISToken";
import DownloadBlob from "utils/DownloadBlob";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import ReactInnerText from "utils/ReactInnerText";
let cachedHighlight = [-1, false];
let allGraphics = null;
let lastSlopeGraphics = null;
let highlightLayer = null;
let mmsLayer = null;
let attrTitleStyle = {
  fontWeight: "bold",
  fontSize: "13px",
  textDecoration: "underline",
};
let ZoomToInstance = undefined;
class ResultList extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      resultListOrder: "Asc",
      isHightlight: [-1, false],
      activePanel: 0,
    };
    let component = React.createElement(ZoomTo, props);
    ZoomToInstance = new component.type(props);
    ZoomToInstance.props = props;
  }
  componentDidMount() {
    highlightLayer = geometryTools.createGraphicsLayerById(
      "highlightLayerForSearchResult",
      this.props.mapView.map
    );
    let firstResultCat = this.props.allResults?.[0];
    let searchType = firstResultCat?.searchInfo?.type;
    if (searchType !== "uav")
      geometryTools.refreshGraphicByLayerId(
        this.props.mapView,
        "highlightLayerForMMS",
        this.props.allResults
          .map((i) => i.results)
          .flat()
          .map((i) => i.geometry),
        true,
        searchType === "mms",
        false
      );
    this.removeAllGraphics();

    if (
      this.props.allResults.length === 1 &&
      firstResultCat?.results.length === 1
    ) {
      if (searchType === "mms" || searchType === "gireport") {
        this.props.onSubPanelCallback("showItemDetail", [
          firstResultCat?.results[0],
          firstResultCat?.searchInfo,
        ]);
      } else {
        this.mouseEventHandler(
          "click",
          firstResultCat.searchInfo,
          firstResultCat?.results[0],
          0
        );
      }
    }

    let activePanel = 0;
    (this.props.allResults || []).some(
      (i, j) => i.results.length > 0 && ((activePanel = j), true)
    );
    this.setState({ activePanel });
  }
  componentWillUnmount() {
    cachedHighlight = this.state.isHightlight;
  }
  highlightFeature(geometry, isSlope = false) {
    if (!geometry) return;
    // if (!allGraphics) allGraphics = highlightLayer.graphics.toArray();
    highlightLayer.removeAll();
    let graphic = new geometryTools.Graphic({
      geometry,
      symbol: geometryTools.highlightSymbol[geometry.type],
    });
    if (isSlope) {
      graphic.symbol.outline.color = "#F00";
      graphic.symbol.outline.width = 5;
      graphic.symbol.color = undefined;
    } else graphic.symbol.color = "#F00";
    highlightLayer.add(graphic);
  }
  removeAllGraphics() {
    // if (allGraphics) {
    highlightLayer.removeAll();
    // highlightLayer.addMany(allGraphics);
    // allGraphics = null;
    // }
  }
  attrTableTransform(attributes, oldAttr, searchInfo) {
    return typeof searchInfo.attrTransform !== "undefined"
      ? searchInfo.attrTransform(
          attributes,
          oldAttr,
          GetArcGISToken.user,
          this.props.showDialog
        )
      : searchInfo.aliasList.map((i) => ({
          Name: (() => {
            if (i.type === "title")
              return <span style={attrTitleStyle}>{i.Name}</span>;
            else return i.Name;
          })(),
          Value: (() => {
            if (i.type === "title") return "";
            let value = attributes[i.Value];
            if (typeof value === "undefined") return value;
            if (i.type === "date") return moment(value).format("DD/MM/YYYY");
            else if (i.format)
              return value ? i.format(value, attributes) : value;
            else return value;
          })(),
        }));
  }
  exportToPdf(title, attr, evt) {
    // console.log(title, attr, evt);
    evt.stopPropagation();
    attr = attr.map((i) => {
      let row = {};
      ["Name", "Value"].forEach((attrName) => {
        console.debug(i[attrName]);
        if (attrName == "Value" && i[attrName] instanceof Element) {
          i[attrName].childNodes.forEach((node, index) => {
            if (index == 0) {
              row[attrName] = "";
            }
            if (node.tagName == "SPAN") {
              row[attrName] += `${node.childNodes[0].data} Open ${
                node.childNodes[1].href
              }\n`;
            }
          });
        } else {
          row[attrName] = ReactInnerText(i[attrName]);
        }
      });
      return row;
    });
    title = encodeURI(title);
    attr = encodeURI(JSON.stringify(attr));
    let tempForm = document.createElement("FORM");
    tempForm.method = "post";
    tempForm.target = "_blank";
    tempForm.action = this.$config.baseUrl + "/GInfoMap/export.aspx";
    tempForm.innerHTML = `<input type="hidden" name="title" value="${title}"/><input type="hidden" name="json" value="${attr}"/>`;
    document.body.appendChild(tempForm);
    tempForm.submit();
    document.body.removeChild(tempForm);
  }
  async mouseEventHandler(eventType, searchInfo, k, j, isCustomSearch) {
    let vm = this;
    let type = searchInfo.type;
    let detailType = searchInfo.itemDetailType;
    if (detailType === "mms") {
      if (eventType === "click") {
        this.setState({ isHightlight: [j, true] });
        geometryTools.zoomToGraphic(this.props.mapView, k.geometry);
        this.props.onSubPanelCallback("showItemDetail", [k, searchInfo]);
        // this.props.reduxCallProxy(rememberViewingResultItem, k);
      } else if (eventType === "mouseover") {
        this.highlightFeature(k.geometry, true);
      } else if (eventType === "mouseleave") {
        this.removeAllGraphics();
      }
    } else if (detailType === "gireport" && eventType === "click") {
      if (k.key.startsWith("R")) {
        if (GetArcGISToken.user.userGroup === 5) {
          this.props.showDialog({
            isOpen: true,
            type: "error",
            title: "GIU Report",
            content: "Access Denied",
            onDialogOk: () => {},
          });
          return;
        }
      }
      this.setState({ isHightlight: [j, true] });
      this.props.onSubPanelCallback("showItemDetail", [k, searchInfo]);
    } else if (type === "uav") {
      let uavPt = this.props.mapView.map.allLayers.find(
        (i) => i.title === "UAV Image Point"
      );
      let uavPath = this.props.mapView.map.allLayers.find(
        (i) => i.title === "UAV Flight Path"
      );
      let uavPtView = await this.props.mapView.whenLayerView(uavPt);
      let uavPathView = await this.props.mapView.whenLayerView(uavPath);
      if (uavPtView && uavPathView) {
        let { SETNUMBER, SITENAME } = k.attributes;
        if (eventType === "mouseover") {
          uavPtView.filter = uavPathView.filter = {
            where: `SETNUMBER='${SETNUMBER}' and SITENAME='${SITENAME}'`,
          };
        } else if (eventType === "mouseleave") {
          if (this.state.isHightlight[0] !== j) {
            uavPtView.filter = undefined;
            uavPathView.filter = undefined;
          }
        } else if (eventType === "click") {
          let geometry = await uavPtView.queryExtent({
            where: `SETNUMBER='${SETNUMBER}' and SITENAME='${SITENAME}'`,
          });
          geometry = geometry.extent;
          geometry.expand(1.5);
          geometryTools.zoomToGraphic(this.props.mapView, geometry);
          this.setState({ isHightlight: [j, true] });
        }
        return;
      }
    } else if (detailType === "newfeatno" && eventType === "click") {
      let mmsSearchInfo = config_textual_search.find(
        (i) => i.name == "Man-made Features"
      );
      ZoomToInstance.textualSearchCallback(
        mmsSearchInfo,
        k.attributes.NEW_FEATREF
      );
    } else {
      let geometry = k.geometry;
      if (eventType === "mouseover") {
        this.highlightFeature(geometry);
      } else if (eventType === "click") {
        geometryTools.zoomToGraphic(this.props.mapView, geometry);
        if (isCustomSearch) {
          searchInfo = config_graphical_search.find(
            (i) => i.name === searchInfo.name
          );
        }
        this.setState({ isHightlight: [j, true] });
        if (searchInfo.itemDetailType === "messagebox") {
          this.props.showDialog({
            type: "info",
            isOpen: true,
            title: searchInfo.name,
            content: searchInfo.msgBoxText,
            onDialogOk: () => {},
          });
          return;
        }
        if (
          searchInfo.itemDetailType === "attrTbl" ||
          (searchInfo.itemDetailType === "API" && searchInfo.aliasList)
        ) {
          k = { ...k, attributes: { ...k.attributes } };
          let oldAttr = { ...k.attributes };
          if (searchInfo.itemDetailType === "API") {
            this.props.showDialog({
              isOpen: true,
              title: "Loading",
              content: (
                <div>
                  <span className="icn_loading" />
                  Getting search item detail for item {k.text} ...
                </div>
              ),
            });
            k.attributes = Object.keys(k.attributes).reduce((p, c, i) => {
              let dotIndex = c.indexOf(".");
              let newKey = c;
              if (dotIndex > 0) newKey = c.substr(dotIndex + 1);
              p[newKey] = k.attributes[c];
              return p;
            }, {});
            let result = await this.fetchQueryByPOST(
              `${this.$config.webSrvUrl}WebAPI/GInfo/${searchInfo.srvEndPt}`,
              typeof searchInfo.queryValue === "function"
                ? searchInfo.queryValue(k.attributes)
                : { Key: k.attributes[searchInfo.queryValue] },
              true
            );
            result = await result.json();
            if (Array.isArray(result)) k.attributes = result;
            else k.attributes = { ...k.attributes, ...result };
            this.props.showDialog({
              isOpen: false,
            });
          }
          this.props.mapView.popup.visible = false;
          // Pause for a bit, let Javscript close the popup
          await new Promise((r) => setTimeout(r, 100));
          let cloneGraphic = new geometryTools.Graphic(k);
          let title =
            "<div class='ResultDetailPopupTitle' style='width:100%'><span>" +
            searchInfo.name +
            "</span> </div>";
          cloneGraphic.popupTemplate = {
            title,
            content: function(feature) {
              let content = document.createElement("DIV");
              let root = ReactDOM.createRoot(content);
              setTimeout(() => {
                root.render(
                  <DivTable
                    LayerTitle={title}
                    hideHeader={true}
                    data={vm.attrTableTransform(
                      k.attributes,
                      oldAttr,
                      searchInfo
                    )}
                    columnDef={[
                      {
                        name: "Name",
                        value: "Name",
                      },
                      {
                        name: "Value",
                        value: "Value",
                      },
                    ]}
                  />
                );
              });
              return content;
            },
          };
          if (true) {
            const addExportButton = () => {
              let exportBtnPh = document.querySelector(
                ".ResultDetailPopupTitle"
              );
              if (
                !!exportBtnPh &&
                !document.querySelector(".SearchResultPopupExportPDF")
              ) {
                let dlButton = document.createElement("SPAN");
                dlButton.className =
                  "SearchResultPopupExportPDF icn_download icon_m";
                dlButton.style.pointerEvents = "all";
                dlButton.onclick = vm.exportToPdf.bind(
                  vm,
                  searchInfo.allowSavePdf,
                  vm.attrTableTransform(k.attributes, oldAttr, searchInfo)
                );
                exportBtnPh.insertAdjacentElement("beforeend", dlButton);
              }
            };

            reactiveUtils
              .once(() => this.props.mapView.popup.visible === true)
              .then((newV) => {
                console.debug("Popup open!");
                let timer = setInterval(() => {
                  let exportBtnPh = document.querySelector(
                    ".ResultDetailPopupTitle"
                  );
                  if (!!exportBtnPh) {
                    clearInterval(timer);
                    // let dlButton = document.createElement("SPAN");
                    // dlButton.className =
                    //   "SearchResultPopupExportPDF icn_download icon_m"; // icn_pdf
                    // dlButton.style.pointerEvents = "all";
                    // dlButton.onclick = vm.exportToPdf.bind(
                    //   vm,
                    //   searchInfo.allowSavePdf,
                    //   vm.attrTableTransform(k.attributes, oldAttr, searchInfo)
                    // );
                    // exportBtnPh.insertAdjacentElement("beforeend", dlButton);
                    addExportButton();
                  }

                  // Add event listener for window resize
                });
                window.addEventListener("resize", () => {
                  setTimeout(() => {
                    addExportButton();
                  }); // Delay to ensure the popup content is re-rendered
                });
              });
          }

          // console.log(this.props.mapView.popup.container);

          this.props.mapView.popup.open({
            features: [cloneGraphic],
            location: k.geometry.extent?.center || k.geometry,
          });
        }
      } else if (eventType === "mouseleave") {
        this.removeAllGraphics();
      }
    }
  }

  // makePopupMovableAndResizable(popup) {
  //   const popupContainer = popup.container;
  //   const header = popupContainer.querySelector(".esri-popup");

  //   let isDragging = false;
  //   let startX, startY, initialLeft, initialTop;

  //   header.addEventListener("mousedown", function(evt) {
  //     isDragging = true;
  //     startX = evt.clientX;
  //     startY = evt.clientY;
  //     initialLeft = popupContainer.offsetLeft;
  //     initialTop = popupContainer.offsetTop;

  //     document.addEventListener("mousemove", onMouseMove);
  //     document.addEventListener("mouseup", onMouseUp);
  //   });

  //   function onMouseMove(evt) {
  //     if (!isDragging) return;
  //     const dx = evt.clientX - startX;
  //     const dy = evt.clientY - startY;
  //     popupContainer.style.left = `${initialLeft + dx}px`;
  //     popupContainer.style.top = `${initialTop + dy}px`;
  //     popupContainer.style.position = "absolute";
  //   }

  //   function onMouseUp() {
  //     isDragging = false;
  //     document.removeEventListener("mousemove", onMouseMove);
  //     document.removeEventListener("mouseup", onMouseUp);
  //   }

  //   // Ensure popup is resizable
  //   popupContainer.style.resize = "both";
  //   popupContainer.style.overflow = "auto";
  // }

  exportCustomSearchCsv() {
    let { isCustomSearch } = this.props;
    let sb = [];
    let exportFileName = "data.csv";
    if (isCustomSearch) {
      sb.push(["Layer Name,Value"]);
      exportFileName = "CustomSearchResult.csv";
    }
    this.props.allResults.forEach((i) => {
      if (i.searchInfo.customIdentifyExportFormat) {
        let newSb = [];
        i.searchInfo.customIdentifyExportFormat(
          newSb,
          i.results,
          isCustomSearch
        );
        if (isCustomSearch) {
          newSb = newSb.map((j) => i.searchInfo.name + "," + j);
        }
        sb.push.apply(sb, newSb);
      } else {
        if (!isCustomSearch) sb.push(["Layer Name,Value"]);
        i.results.forEach((j) => {
          let row = [i.searchInfo.name];
          let values = i.searchInfo.resultItemFormatter
            ? i.searchInfo.resultItemFormatter(j.attributes)
            : !!j.key
            ? [j.key]
            : [
                j.attributes.SA_NO ||
                  j.attributes.FEATURENO ||
                  j.attributes.Tagmark ||
                  "",
              ];

          values = values.map(
            (i) => `${!!i ? i.toString().replace(/\"/g, '""') : ""}`
          );
          row.push.apply(row, values);
          sb.push(`"${row.join('","')}"`);
        });
      }
    });
    DownloadBlob(sb.join("\r\n"), exportFileName, "text/csv", false);
  }

  render() {
    // let { searchType, searchInfo, results } = this.props;
    let isCustomSearch = this.props.isCustomSearch;

    // console.log("check result", this.props?.allResults);
    return (
      <div
        className={`ResultListContainer${
          isCustomSearch ? " CustomSearch" : ""
        }`}
      >
        <div className="PanelTitle">
          <span>{this.props.searchType || "Search Result"}</span>
          <div>
            <span
              className="ActionBtn icn_3d_Elevationprofile_export"
              onClick={() => this.exportCustomSearchCsv()}
            />
          </div>
        </div>
        <div className="SearchResultList">
          {!isCustomSearch &&
            (this.props.allResults || []).map(
              (resultCat, catIdx, allResult) => {
                let { searchInfo, results } = resultCat;
                let isActive = this.state.activePanel === catIdx;
                let expandedPanelHeight = (allResult.length - 1) * 50;
                if (searchInfo.name === "GIU Report")
                  results = results.filter((i) => i.key !== "DUMMY_CELL");
                function sortResults(info, list, isAsc) {
                  return list.sort((a, b) => {
                    let val_a = "";
                    let val_b = "";
                    if (info.resultItemFormatter) {
                      val_a = info.resultItemFormatter(a.attributes);
                      val_b = info.resultItemFormatter(b.attributes);
                    }
                    if (
                      (val_a == "" && val_b == "") ||
                      (typeof val_a == "object" || typeof val_b == "object")
                    ) {
                      val_a = a.text;
                      val_b = b.text;
                    }
                    if (val_a < val_b) {
                      return isAsc ? -1 : 1;
                    } else if (val_a > val_b) {
                      return isAsc ? 1 : -1;
                    } else {
                      return 0;
                    }
                  });
                }
                results = sortResults(
                  searchInfo,
                  results,
                  this.state.resultListOrder == "Asc"
                );
                return (
                  <MiniPanel
                    key={`${searchInfo.name}-${catIdx}`}
                    titleText={
                      <span
                        style={{
                          cursor: `pointer`,
                          height: `100%`,
                          width: `100%`,
                          display: `inline-flex`,
                          margin: `0 auto`,
                          paddingLeft: `10px`,
                          alignItems: `center`,
                        }}
                        onClick={() => {
                          let resultListOrder = "";
                          if (this.state.resultListOrder == "Asc") {
                            resultListOrder = "Desc";
                          } else {
                            resultListOrder = "Asc";
                          }
                          this.setState({
                            activePanel: catIdx,
                            resultListOrder: resultListOrder,
                          });
                        }}
                      >{`${searchInfo.name} (${results.length})`}</span>
                    }
                    titleClass="ListTitle"
                    collapsed={!isActive}
                    style={
                      this.props.searchType === "Textual Results" &&
                      searchInfo.name.toUpperCase().includes("ENTLI")
                        ? {}
                        : isActive && {
                            height: `calc(100% - ${expandedPanelHeight}px)`,
                          }
                    }
                    // key={`${i}-${j}`}
                    ResultList={true}
                  >
                    {results.map((k, j) => (
                      <div key={`ResultListItem-${j}`} className="ListItems">
                        <div
                          key={`${j}-${0}-${k}`}
                          className={
                            this.state.isHightlight[0] === j &&
                            this.state.isHightlight[1]
                              ? "highlight-result"
                              : ""
                          }
                          onClick={() =>
                            this.mouseEventHandler(
                              "click",
                              searchInfo,
                              k,
                              j,
                              isCustomSearch
                            )
                          }
                          onMouseOver={() =>
                            this.mouseEventHandler(
                              "mouseover",
                              searchInfo,
                              k,
                              j
                            )
                          }
                          onMouseLeave={() =>
                            this.mouseEventHandler(
                              "mouseleave",
                              searchInfo,
                              k,
                              j
                            )
                          }
                        >
                          {searchInfo.resultItemFormatter
                            ? searchInfo.resultItemFormatter(k.attributes)
                            : !!k.text
                            ? k.text
                            : k.attributes.SA_NO ||
                              k.attributes.FEATURENO ||
                              k.attributes.Tagmark ||
                              ""}
                        </div>
                      </div>
                    ))}
                    {results.length === 0 && (
                      <div className="SubPanelContent AlignCentre">
                        No search result
                      </div>
                    )}
                  </MiniPanel>
                );
              }
            )}
          {isCustomSearch && (
            <DivTable
              data={(this.props.allResults || [])
                .map((resultCat) => {
                  let searchInfo = resultCat.searchInfo;
                  return resultCat.results.map((k) => ({
                    layer: searchInfo.name,
                    displayText: searchInfo.resultItemFormatter
                      ? searchInfo.resultItemFormatter(k.attributes)
                      : (k.text || "").toString().trim() || "<Empty String>",
                    graphic: k,
                    searchInfo,
                  }));
                })
                .flat()}
              columnDef={[
                {
                  name: "Source",
                  value: "layer",
                },
                {
                  name: "Item",
                  value: "displayText",
                  format: (v, r) => (
                    <a
                      href="javascript:void(0)"
                      onClick={() =>
                        this.mouseEventHandler(
                          "click",
                          r.searchInfo,
                          r.graphic,
                          0,
                          true
                        )
                      }
                      onMouseOver={() =>
                        this.mouseEventHandler(
                          "mouseover",
                          r.searchInfo,
                          r.graphic,
                          0,
                          true
                        )
                      }
                      onMouseLeave={() =>
                        this.mouseEventHandler(
                          "mouseleave",
                          r.searchInfo,
                          r.graphic,
                          0,
                          true
                        )
                      }
                    >
                      {v}
                    </a>
                  ),
                },
              ]}
            />
          )}
          {!this.props.allResults?.length && (
            <div className="SubPanelContent">
              Get started by starting a new search!
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ResultList;
